import React, { useEffect } from "react";
import './aboutUs.css'
import Aos from "aos";
import "aos/dist/aos.css";
// import { Link } from "react-router-dom";
import MainImg from "../../assets/about-build.png";

export const AboutUs = () => {

    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, []);


  return (
    <div className="aboutUs">
        <div className="responsive-container-block bigContainer">
            <div className="responsive-container-block Container">
                <div className="imgContainer">
                <img
                    data-aos="fade-up" data-aos-duration="600"
                    className="blueDots"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw3.svg"
                    alt="Blue Dots"
                />
                <img
                    data-aos="fade-up" data-aos-duration="600"
                    className="mainImg"
                    src={MainImg}
                    alt="Main"
                />
                </div>
                <div className="responsive-container-block textSide">
                    <p className="text-blk heading" data-aos="fade-left" data-aos-duration="900">
                        We are here to help
                    </p>
                    <p className="text-blk subHeading" data-aos="fade-left" data-aos-duration="1000">
                        At Stannum HR Consultancies LLC, we specialize in providing comprehensive HR solutions and work visa 
                        services in Dubai. As a trusted partner, we combine our extensive industry expertise with an 
                        in-depth understanding of local regulations to deliver seamless and efficient services. 
                        Our mission is to simplify the complexities of securing work visas and managing HR requirements, 
                        ensuring a hassle-free experience for our clients. Whether you're an organization looking to 
                        streamline your HR operations or a professional seeking a smooth relocation process, 
                        Stannum HR Consultancies LLC is here to support you every step of the way.
                    </p>
                    
                    <a href="/about">
                        <button className="explore"
                        data-aos="zoom-in" data-aos-duration="1000"
                        >
                            Read more
                        </button>
                    </a>
                    {/* <Link
                        to="/about"
                        className="homeSeg-target_button"
                        data-aos="zoom-in"
                        data-aos-duration="1000"
                        >
                        Read more
                    </Link> */}
                </div>
                <img
                    className="redDots"
                    src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/cw3.svg"
                    alt="Red Dots"
                />
            </div>
        </div>
    </div>
  );
}
